const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const PackListReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_PACK_LIST_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_PACK_LIST_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_PACK_LIST_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      case "CLEAR_PACK_LIST":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default PackListReducer;